module.exports = __webpack_public_path__ + "media/images/plans/icon-feature-dress-4308b88884c6f77cf2b2ac9a42cbb73b.png";